var _clipPath, _clipPath2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleFlyerDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 2481 3509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2688 .3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2688.65 0h2480.32v3507.87H2688.65z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2688.65 0h2480.32v3507.87H2688.65z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35.433-35.433h2551.18v1027.56H-35.433z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(1 0 0 3.48276 2688.65 87.972)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6336.38 17542.4h2354.59v2504.29H6336.38z",
    style: {
      fill: "#2c2926"
    },
    transform: "matrix(.54175 0 0 .4521 496.091 -7966.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6336.38 17542.4h2354.59v2504.29H6336.38z",
    style: {
      fill: "#c4ab75"
    },
    transform: "matrix(.54175 0 0 .4521 -779.5 -7966.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8255.16 17144.8c0-5.4-9.91-10.6-27.56-14.4-17.64-3.8-41.57-6-66.53-6H6674.45c-24.95 0-48.88 2.2-66.52 6-17.65 3.8-27.56 9-27.56 14.4v29.1h1674.79v-29.1Z",
    style: {
      fill: "#2b2927"
    },
    transform: "matrix(.76577 0 0 3.52792 -1753.862 -59420.63)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.61873 0 0 .43074 -13396.692 -6353.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6859.93 17137.4c0-45.1-6.03-81.7-13.45-81.7h-460.51c-8.71 0-15.78 42.9-15.78 95.9v342.3c0 45.1 6.03 81.8 13.45 81.8h462.84c7.42 0 13.45-36.7 13.45-81.8v-356.5Z",
    style: {
      fill: "#2b2927"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6859.93 17137.4c0-45.1-6.03-81.7-13.45-81.7h-460.51c-8.71 0-15.78 42.9-15.78 95.9v342.3c0 45.1 6.03 81.8 13.45 81.8h462.84c7.42 0 13.45-36.7 13.45-81.8v-356.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6370.19 17055.7h489.74v520h-489.74z",
    style: {
      fill: "#c4ab75"
    },
    transform: "matrix(1 0 0 .22021 0 13705.3)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6859.93 17137.4c0-45.1-7.22-81.7-16.1-81.7h-454.75c-10.43 0-18.89 42.9-18.89 95.9v342.3c0 45.1 7.21 81.8 16.1 81.8h457.54c8.88 0 16.1-36.7 16.1-81.8v-356.5Z",
    style: {
      fill: "#2b2927"
    },
    transform: "matrix(3.41975 0 0 .67336 -18693.092 -10125.03)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleFlyerDouble);
export default __webpack_public_path__ + "static/media/simpleFlyerDouble.d349e2b816636199ec1b33397360cfe9.svg";
export { ForwardRef as ReactComponent };